export default __webpack_public_path__ + "static/media/micro-required-pour.1fc89ff0.png";